import React, { useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import { useNavigate } from 'react-router-dom';
import { managerApi } from 'apis/manager/managerApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import MainTable from 'components/table/MainTable';
import TableToolbar from 'components/table/TableToolbar';
import SearchInput from 'components/search/SearchInput';
import TextButton from 'components/button/TextButton';
import { useTranslation } from 'react-i18next';
/**
 * * 관리자 관리 - 관리자 목록
 */

const ManagerListPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState();
  const [datas, setDatas] = useState();

  const handleLink = (record) => () => {
    navigate(`/manager/${record.userId}`, { state: { record: record } });
  };

  const fetchData = async () => {
    const res = await managerApi.read();
    console.log(res);
    setDatas(res);
  };

  const columnsOrigin = [
    {
      title: t('manager.table.userName'),
      dataIndex: 'userName',
      width: '12rem',
      render: (text, record) => (
        <TextButton onClick={handleLink(record)}>{text}</TextButton>
      ),
      sorter: (a, b) =>
        a.userName.localeCompare(b.userName, undefined, {
          sensitivity: 'base',
        }),
    },
    {
      title: t('manager.table.userEmail'),
      dataIndex: 'userEmail',
      sorter: (a, b) =>
        a.userEmail.localeCompare(b.userEmail, undefined, {
          sensitivity: 'base',
        }),
      render: (text, record) => (
        <TextButton onClick={handleLink(record)}>{text}</TextButton>
      ),
    },
    {
      title: t('manager.table.userOrganization'),
      dataIndex: 'userOrganization',
      sorter: (a, b) =>
        a.userOrganization.localeCompare(b.userOrganization, undefined, {
          sensitivity: 'base',
        }),
    },
    {
      title: t('manager.table.userMaster'),
      dataIndex: 'userMaster',
      render: (text, record) => (
        <Checkbox checked={record.userMaster === 1 ? true : false} disabled />
      ),
    },
    {
      title: t('manager.table.userProject'),
      dataIndex: 'userProject',
      render: (text, record) => (
        <Checkbox checked={record.userProject === 1 ? true : false} disabled />
      ),
    },
    {
      title: t('manager.table.userPlatformName'),
      dataIndex: 'userPlatform_name',
      render: (text, record) => (
        <Checkbox
          checked={record.userPlatform !== '' ? true : false}
          disabled
        />
      ),
    },
    {
      title: t('manager.table.userManagementName'),
      dataIndex: 'userManagement_name',
      render: (text, record) => (
        <Checkbox
          checked={record.userManagement !== '' ? true : false}
          disabled
        />
      ),
    },
  ];
  useEffect(() => {
    fetchData().catch(console.log);
  }, []);
  return (
    <DefaultLayout>
      <TableToolbar>
        <SearchInput
          placeholder={t('manager.inputPlaceHolder')}
          setSearchData={setSearchData}
        />
      </TableToolbar>
      <MainTable
        columns={columnsOrigin}
        dataSource={
          searchData
            ? datas.filter(
                (data) => data?.userName?.indexOf(searchData || '') !== -1,
              )
            : datas
        }
        pagination={{
          showSizeChanger: true,
          defaultPageSize: 15,
        }}
      />
    </DefaultLayout>
  );
};

export default ManagerListPage;
